import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-terms-of-telemedicine',
    templateUrl: './terms-of-telemedicine.component.html',
    styleUrls: ['./terms-of-telemedicine.component.scss'],
    encapsulation: ViewEncapsulation?.None,
    standalone: false
})
export class TermsOfTelemedicineComponent {



}
